module.exports = parcelRequire.resolve("f94EK");